import envs from "./envs";

export default [
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-na-Planta.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-na-Planta.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-na-Planta-que-esta-Financiado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-na-Planta-que-esta-Financiado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imóvel-que-esta-Financiado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Im%C3%B3vel-que-esta-Financiado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-Residencial-Comercial-Misto-ou-Terreno.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-Residencial-Comercial-Misto-ou-Terreno.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-Rural.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-Rural.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-Rural-que-esta-Financiado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Imovel-Rural-que-esta-Financiado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Veiculo-Novo.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Veiculo-Novo.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Quitar-Financiamento-de-Imovel-Proprio.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Quitar-Financiamento-de-Imovel-Proprio.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Quitar-Financimento-de-Veiculo-Proprio.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Quitar-Financimento-de-Veiculo-Proprio.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Declaracao-de-Transferencia-de-Imovel-Foreiro.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Declaracao-de-Transferencia-de-Imovel-Foreiro.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Garantias-Excluidas-Imovel.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Garantias-Excluidas-Imovel.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Substituicao-de-Garantia-Imovel.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Substituicao-de-Garantia-Imovel.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Substituicao-de-Garantia-Veiculos.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Substituicao-de-Garantia-Veiculos.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Maquina-Equipamento-Embarcacao-Aeronave.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Maquina-Equipamento-Embarcacao-Aeronave.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Veiculo-Usado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Check-List-Comprar-Veiculo-Usado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Quitar-Financimento-de-Veiculo-Proprio.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Quitar-Financimento-de-Veiculo-Proprio.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Veiculo-Usado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Veiculo-Usado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Maquina-Equipamento-Embarcacao-Aeronave.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Maquina-Equipamento-Embarcacao-Aeronave.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Veiculo-com-Cota-Quitada.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Veiculo-com-Cota-Quitada.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Veiculo-Novo.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Veiculo-Novo.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar Imovel-Rural-que-esta-Financiado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar Imovel-Rural-que-esta-Financiado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-com-Cota-Quitada.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-com-Cota-Quitada.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Comercial-ou-Misto.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Comercial-ou-Misto.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Comercial-que-esta-Financiado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Comercial-que-esta-Financiado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-na-Planta.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-na-Planta.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-na-Planta-que-esta-Financiado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-na-Planta-que-esta-Financiado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Residencial.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Residencial.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Residencial-que-esta-Financiado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Residencial-que-esta-Financiado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Rural.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Imovel-Rural.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Terreno.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Terreno.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Terreno-que-esta-Financiado.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Comprar-Terreno-que-esta-Financiado.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Quitar-Financiamento-de-Imovel-Proprio.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Quitar-Financiamento-de-Imovel-Proprio.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Entrega-do-bem/Caixa-Seguradora-Cartilha-Quitar-Financiamento-de-Terreno-Proprio.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Entrega-do-bem/Caixa-Seguradora-Cartilha-Quitar-Financiamento-de-Terreno-Proprio.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Cartilhas/Cartilha_de_Construcao_Reforma_e_Ampliacao.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Cartilha_de_Construcao_Reforma_e_Ampliacao.pdf`,
  ],
  [
    "/paravoce/consorcios/teste.pdf",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CheckLists/Cartilha_de_Construcao_Reforma_e_Ampliacao.pdf`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Arquivos_Pos_Contemplacao/Pedido_de_Utilizacao_da_Carta_de_Credito_Pessoa_Fisica_-_Veiculos_Automotores.doc",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/PessoaFisica/Veiculos/Pedido_de_Utilizacao_da_Carta_de_Credito_Pessoa_Fisica_-_Veiculos_Automotores.doc`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Arquivos_Pos_Contemplacao/Pedido_de_Utilizacao_da_Carta_de_Credito_Pessoa_Juridica_-_Veiculos_Automotores.doc",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/PessoaJuridica/Veiculos/Pedido_de_Utilizacao_da_Carta_de_Credito_Pessoa_Juridica_-_Veiculos_Automotores.doc`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Arquivos_Pos_Contemplacao/Pedido_de_Utilizacao_da_Carta_de_Credito_Pessoa_Fisica_-_Imobiliario.doc",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/PessoaFisica/Imobiliario/Pedido_de_Utilizacao_da_Carta_de_Credito_Pessoa_Fisica_-_Imobiliario.doc`,
  ],
  [
    "/paravoce/consorcios/Biblioteca de Documentos/Arquivos_Pos_Contemplacao/Pedido_de_Utilizacao_da_Carta_de_Credito_Pessoa_Juridica_-_Imobiliario.doc",
    `${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/PessoaJuridica/Imobiliario/Pedido_de_Utilizacao_da_Carta_de_Credito_Pessoa_Juridica_-_Imobiliario.doc`,
  ],
];
